import type { ThemeAppearance } from '@atlaskit/lozenge';
import { IN_PROGRESS, DONE } from '@atlassian/jira-common-constants/src/status-categories';
import type { JiraStatus } from '../../../../../../common/types';
import type { StatusOption } from './types';

export const getLozengeAppearance = (statusCategory?: string): ThemeAppearance => {
	switch (statusCategory) {
		case IN_PROGRESS:
			return 'inprogress';
		case DONE:
			return 'success';
		default:
			return 'default';
	}
};

export const useStatusOptions = (thirdPartyOptions: JiraStatus[]): StatusOption[] =>
	thirdPartyOptions
		.filter((obj1, i, arr) => arr.findIndex((obj2) => obj2.name === obj1.name) === i)
		.map((status) => ({
			label: status.name,
			value: status.name,
			statusCategory: status.statusCategory,
			appearance: getLozengeAppearance(status.statusCategory),
		}));
